import type { Passenger } from '@aviata/booking-data';

import type { DocScanData } from '../api/doc-scan';

/**
 * The doc-scan API returns dates in `YYYY-MM-DD`; the rest of the app
 * carries them as `DD.MM.YYYY`. Used by `mapScanDataToPassenger`.
 */
const reformatApiDate = (apiDate: string): string => {
  const [year, month, day] = apiDate.split('-');
  return `${day}.${month}.${year}`;
};

export const mapScanDataToPassenger = (data: DocScanData): Passenger => {
  return {
    firstName: data.first_name,
    lastName: data.last_name,
    gender: data.gender,
    dob: reformatApiDate(data.dob),
    citizenship: data.citizenship,
    iin: data.iin ?? '',
    airlineBonusCard: '',
    document: {
      number: data.document.number,
      expiresAt: data.document.expires_at
        ? reformatApiDate(data.document.expires_at)
        : '',
    },
  } as Passenger;
};
